import { makeAPI } from 'api'

import mcApi from 'utils/api/mcApi/mcApi'

export const api = makeAPI(mcApi)
